import React, { createContext, useContext, useReducer } from 'react';

const AppContext = createContext();

const initialState = {
  user: null,
  projects: [],
  loading: false,
  error: null,
  projectDraft: {},
  categories: [],
  templates: [],
  instructionLists: [],
  sessionStatus: 'inactive',
};

function appReducer(state, action) {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    case 'SET_USER':
      return { ...state, user: action.payload };
    case 'SET_PROJECTS':
      return { ...state, projects: action.payload };
    case 'UPDATE_PROJECT_DRAFT':
      return { ...state, projectDraft: { ...state.projectDraft, ...action.payload } };
    case 'SET_CATEGORIES':
      return { ...state, categories: action.payload };
    case 'SET_TEMPLATES':
      return { ...state, templates: action.payload };
    case 'SET_INSTRUCTION_LISTS':
      return { ...state, instructionLists: action.payload };
    case 'SET_SESSION_STATUS':
      return { ...state, sessionStatus: action.payload };
    default:
      return state;
  }
}

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);
  const value = { ...state, dispatch };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
}